import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const BreadcrumbCateDetails = ({ items }) => {
  const location = useLocation();
  const { pathname } = location;
  const pathSegments = pathname.split("/").filter(Boolean); // removes empty strings

  // Get dynamic city from URL
  const dynamicCityFromURL = pathSegments.length >= 2 ? pathSegments[0] : "";
  const selectedLocation = dynamicCityFromURL.toLowerCase();

  // Set up location dynamic/replace (used if needed elsewhere)
  const [storageData, setStorageData] = useState({
    locationDynamic: "LOCATION_DY",
    locationReplace: selectedLocation,
  });

  useEffect(() => {
    setStorageData({
      locationDynamic: "LOCATION_DY",
      locationReplace: selectedLocation,
    });

    // Check if breadcrumb includes "Home" slug and remove 'hasvisit'
    if (items?.some(item => item.name === "/" || item.name === "\\/")) {
      localStorage.removeItem("city_name");
      localStorage.removeItem("country_name");
    }
  }, [selectedLocation, items]);

  return (
    <div className="d-none d-lg-block breadcrumb-wrapper w-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {/* {items?.map((item, index) => {
              const isLast = index === items.length - 1;
              const slug = item?.slug?.replace(/~/g, "-")?.toLowerCase();
              const url = selectedLocation ? `/${selectedLocation}/${slug}` : `/${slug}`;

              return (
                <li key={index} className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                  {isLast ? (
                    item.name
                  ) : (
                    <Link to={url} className="bread-link">
                      {item.name}
                    </Link>
                  )}
                </li>
              );
            })} */}
            {items?.map((item, index) => {
              const isLast = index === items.length - 1;
              const slug = item?.slug?.replace(/~/g, "-")?.toLowerCase();

              // Handle "Home" slug specifically if it's just "/"
              let url = "/";
              if (slug !== "/" && slug !== "\\/") {
                url = selectedLocation ? `/${selectedLocation}/${slug}` : `/${slug}`;
              }

              return (
                <li key={index} className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                  {isLast ? (
                    item.name
                  ) : (
                    <Link to={url} className="bread-link">
                      {item.name}
                    </Link>
                  )}
                </li>
              );
            })}

          </ol>
        </nav>
      </Container>
    </div>
  );
};

export default BreadcrumbCateDetails;
